import React from 'react';
import PropTypes from 'prop-types';

import {FormInput} from 'components/formInput';
import {Tooltip} from 'components/tooltip';
import {Button} from 'components/button';
import {WithCommonTranslations, WithUserTranslations} from 'components/hocs';
import {TranslationMixin} from 'mixins/translationMixin';
import './LocksmithForm.css';

export const LocksmithForm = WithCommonTranslations(WithUserTranslations(
    class extends TranslationMixin(React.Component) {

        constructor(props) {
            super(props);

            this.state = {
                locksmithIdChanged: false,
            };

            this.onLocksmithIDChange = this.onLocksmithIDChange.bind(this);
        }

        onLocksmithIDChange(event, callback) {
            if (!this.state.locksmithIdChanged) {
                this.setState({
                    locksmithIdChanged: true,
                });
            }

            if (typeof this.props.onChange === 'function') {
                this.props.onChange(event, callback);
            }
        }

      render() {
          let classNames = 'locksmith-login ';
          if (this.props.className) {
              classNames += this.props.className;
          }
          let titleLabel;
          let tooltipName;
          let locksmithLabel;
          if (this.props.regionCode === "AU") {
              titleLabel = this.getTranslation("LABEL_AASRA_CREDENTIAL");
              tooltipName = this.getTranslation('MESSAGE_AASRA_TOOLTIP');
              locksmithLabel = "AASRA ID";
          } else {
              titleLabel = this.getTranslation('LABEL_VEHICLE_SECURITY_CREDENTIAL');
              tooltipName = this.getTranslation('MESSAGE_VSC_TOOLTIP');
              locksmithLabel = this.getTranslation('LABEL_VSC_ID');
          }
          return (
              <div className={classNames}>
                  <div className="locksmith-title">{titleLabel}
                      &nbsp;<Tooltip
                          text={tooltipName}></Tooltip>
                  </div>
                  <div className="locksmith-body clearfix">
                      <FormInput name="locksmithID"
                                 id="locksmithID"
                                 autoComplete="off"
                                 label={locksmithLabel}
                                 readOnly={this.props.readOnly}
                                 value={this.props.locksmithID}
                                 displayError={this.props.isValidated}
                                 onChange={this.onLocksmithIDChange}/>
                      {!this.props.hidePasscode &&
                      <FormInput name="locksmithPasscode"
                                 id="locksmithPasscode"
                                 label={this.getTranslation(
                                     'LABEL_PASSCODE')}
                                 type="password"
                                 autoComplete="off"
                                 readOnly={this.props.readOnly}
                                 value={this.props.locksmithPasscode}
                                 displayError={this.props.isValidated}
                                 required={!!this.props.locksmithID &&
                                 this.state.locksmithIdChanged}
                                 onChange={this.props.onChange}/>}
                      {this.props.showDelete && this.props.locksmithID && <div>
                          <Button variant="link" type="button" className="float-right"
                                  onClick={this.props.onDelete}>
                              {this.getTranslation("LABEL_DELETE")}</Button>
                      </div>}

              </div>
            </div>
        );
      }
    }));

LocksmithForm.propTypes = {
    readOnly: PropTypes.bool,
    className: PropTypes.string,
    locksmithID: PropTypes.string.isRequired,
    isValidated: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    locksmithPasscode: PropTypes.string,
    hidePasscode: PropTypes.bool,
    showDelete: PropTypes.bool,
    onDelete: PropTypes.func
};